import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  login_action,
  forgetPassword_action,
  getOtp_action,
  update_action,
} from "../../actions/user_login_auth_actions/user_login_auth_action";
import { withRouter } from "../../utils/withRouter";
import Loader from "../../utils/Loader";
import { clearSessionStorage, toastError } from "../../utils/constants";
// import Header from '../../common_components/Header';
import {
  emailValidator,
  loginPasswordValidator,
  loginEmailValidator,
  otpValidator,
  confirmPasswordValidator,
  passwordValidator,
} from "../../utils/Validator";
import Modal from "react-modal";
import jQuery from "jquery";
import $ from "jquery";
import ReactDatePicker from "react-datepicker";
import { booking_Details_action } from "../../actions/bookingDetails_action/bookingDetails_action";
// import Footerlogin from '../../common_components/Footerlogin';
// import AdminHeader from '../../common_components/admin_module_header';

/*
 * mapDispatchToProps
 */
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/*
 * mapStateToProps
 */

// const mapStateToProps = state => {
//   return {
//     loginData: state,
//   };
// }

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userEmail: "",
      password: "",
      is_showpass: false,
      email: "",
      is_forgotPassword: false,
      isLoading: false,
      is_rememberme: false,
      is_verifyEmail: false,
      is_verifyOTP: false,
      verifyEmail: "",
      userName: "",
      getOtp: "",
      adminOtp: "",
      forgetNewPass: "",
      forgetConfirmPass: "",
      finalForgetButton: false,
      companyInfo: false,

      //forget
      forgetPassEmail: "",
      OTP: "",
      newPassword: "",
      confirmPassword: "",
      CenterID: "",

      OrderID: "",
    };
    // this.handleObscure = this.handleObscure.bind(this)
    this.toggleModal = this.toggleModal.bind(this);
    // this.handleKeyDown = this.handleKeyDown.bind(this)
    // this.forgetPassword = this.forgetPassword.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.jQuerycode = this.jQuerycode.bind(this);
    this.navigateSignUp = this.navigateSignUp.bind(this);
  }

  componentDidMount() {
    this.jQuerycode();
    this.setState({
      companyInfo:
        this.props.location.state != null &&
          this.props.location.state.companyInfo != null
          ? this.props.location.state.companyInfo
          : false,

      CenterID:
        this.props.location.state != null &&
          this.props.location.state.CenterID != null
          ? this.props.location.state.CenterID
          : "",
    });

    setTimeout(() => {
      console.log("login props", this.props);
    }, 200);

    var url;
    if (
      this.props.location.pathname != null &&
      this.props.location.pathname.includes("/login/")
    ) {
      url =
        this.props.location.pathname != null &&
        this.props.location.pathname.split("/login/");
      this.setState({
        OrderID: url != "" ? (url[1] != "" ? url[1].toString() : "") : "",
      });
    }
  }

  jQuerycode = () => {
    // SLIDESHOW

    $(function () {
      $("#slideshow > div:gt(0)").hide();
      setInterval(function () {
        $("#slideshow > div:first")
          .fadeOut(1000)
          .next()
          .fadeIn(1000)
          .end()
          .appendTo("#slideshow");
      }, 3850);
    });
  };

  handleSubmit(event) {
    console.log(event.key, "keycode")
    // if (event.key === "Enter" || event.key === "NumpadEnter") {
    event.preventDefault();
    const { userEmail, password, companyInfo, OrderID } = this.state;
    // this.props.navigate("/dashboard");
    const Status =
      this.props.location.state != null ? this.props.location.state.status : "";
    const myOrderStatus =
      this.props.location.state != null ? this.props.location.state.status : "";

    // console.log("Status-------------->******************************", Status)
    var errMsg = loginEmailValidator(userEmail);
    var errMsg2 = loginPasswordValidator(password);
    if (errMsg != "" || errMsg2 != "") {
      toast.error(errMsg != "" ? errMsg : errMsg2 != "" ? errMsg2 : "", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    } else {
      if (userEmail != " " && password != " ") {
        this.setState({ isLoading: true });
        this.props
          .login_action(userEmail.toString().trim(), password.toString().trim())
          // .login_action(userEmail.toString().trim(), password.toString().trim())
          .then((data) => {
            // console.log("Data12122121 ", data)
            // console.log("Data12122121 ", data.msg)

            if (data.error != 1) {
              setTimeout(() => {

                if (password.includes("CSR")) {
                  this.props.navigate("/changePassword", {
                    state: { is_forgotPassword: true },
                  });
                } else if (companyInfo == true) {
                  this.props.navigate("/companyInfo", {
                    state: { Is_CenterID: true },
                  });
                } else if (Status == "cart") {
                  this.props.navigate("/cart");
                } else if (myOrderStatus == "myOrder") {
                  this.props.navigate("/my_orders");
                } else if (this.props.location.pathname.includes("/login/")) {
                  if (data.data["RoleID"] == 2) {
                    this.props.navigate("/ordersEdit", {
                      state: { OrderID: OrderID },
                    });
                  } else if (data.data["RoleID"] == 3) {
                    this.props.navigate("/my_orders_edit", {
                      state: { OrderID: OrderID },
                    });
                  } else if (data.data["RoleID"] == 4) {
                    toastError("Operations Login is not allowed");
                  } else {
                    this.props.navigate("/normalView");
                  }
                } else if (data.data["RoleID"] == 4) {
                  this.props.navigate("/checkList");
                } else if (data.data["RoleID"] == 13) {
                  this.props.navigate("/thirdPartyOrderList");
                } else {
                  this.props.navigate("/");
                }
                this.setState({ isLoading: false });
              }, 2000);

            } else {
              this.setState({ isLoading: false });
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          })
          .catch((e) => {
            this.setState({ isLoading: false });
            console.log(e);
          });
      } else {
        this.setState({ isLoading: false });

        toast.error("Please check user name and password", {

          position: "top-center",
          theme: "colored",
          autoClose: 1000,
          hideProgressBar: true,
        });
      }
    }
  }
  // }
  // }

  handleKeyDown(e) {
    if (e.code === "Enter") {
      this.handleSubmit(e);
    }
  }

  onVerifyOTP() {
    const { getOtp, is_verifyOTP, is_verifyEmail, adminOtp } = this.state;
    // this.props.navigate("/dashboard");
    this.setState(
      {
        adminOtp: sessionStorage.getItem("NODE_OTP"),
      },
      () => {
        // console.log("adminOtp-------------->", adminOtp)
      }
    );

    var errMsg = otpValidator(getOtp);

    setTimeout(() => {
      if (errMsg != "") {
        toast.error(errMsg != "" ? errMsg : "", {
          position: "top-center",
          theme: "colored",
          autoClose: 1000,
          hideProgressBar: true,
        });
      } else {
        if (getOtp != "") {
          if (sessionStorage.getItem("NODE_OTP") === getOtp) {
            this.setState({
              is_verifyOTP: !is_verifyOTP,
              is_verifyEmail: !is_verifyEmail,
            });
            toast.success("OTP Veryfied", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          } else {
            toast.error("OTP incorrect!", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      }
    }, 500);
  }

  //toggle model for forgot password.................................

  clearValue() {
    this.setState({
      verifyEmail: "",
      userName: "",
      getOtp: "",
      adminOtp: "",
      forgetNewPass: "",
      forgetConfirmPass: "",
      is_verifyOTP: false,
      is_verifyEmail: false,
    });
  }

  toggleModal() {
    const { is_forgotPassword } = this.state;
    if ($(".recovery").hasClass("open")) {
      $(".recovery").removeClass("open").addClass("closed");
      $("#toggle-terms").removeClass("open").addClass("closed");
    } else {
      $(".recovery").removeClass("closed").addClass("open");
      $("#toggle-terms").removeClass("closed").addClass("open");
      this.clearValue();
      this.setState({ is_forgotPassword: true });
    }
  }

  updatePassword(e) {
    e.preventDefault();
    const { forgetNewPass, forgetConfirmPass, is_forgotPassword } = this.state;
    this.setState({ isLoading: true });
    // this.props.navigate("/dashboard");
    // console.log("testing-------------->", forgetNewPass, forgetConfirmPass)
    var errMsg = passwordValidator(forgetNewPass);
    var errMsg2 = confirmPasswordValidator(forgetNewPass, forgetConfirmPass);
    // console.log(errMsg);
    // console.log(errMsg2);
    if (errMsg != "" || errMsg2 != "") {
      toast.error(errMsg != "" ? errMsg : errMsg2 != "" ? errMsg2 : "", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
      this.setState({ isLoading: false });
    } else {
      if (forgetNewPass != "" && forgetConfirmPass != "") {
        this.props
          .update_action(forgetConfirmPass)
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false });
              toast.success("Password Updated SuccessFully!", {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              });
              // document.querySelector(".recovery").style.display = "none";
              this.toggleModal();
              this.clearValue();
            } else {
              this.setState({ isLoading: false });
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
  }

  // handleKeyDown(e) {
  //   if (e.code === 'Enter') {
  //     this.forgetPassword(e)
  //   }
  // }

  navigateSignUp() {
    const { companyInfo } = this.state;
    const CenterID =
      this.props.location.state != null &&
        this.props.location.state.CenterID != null
        ? this.props.location.state.CenterID
        : "";
    if (companyInfo == false) this.props.navigate("/signUp");
    else {
      this.props.navigate("/signUp", {
        state: { companyInfo: true, CenterID: CenterID },
      });
    }
  }

  // this.setState({ is_verifyOTP: !is_verifyOTP, is_verifyEmail: !is_verifyEmail })
  onVerifyEmail(e) {
    const { verifyEmail, is_verifyEmail, is_forgotPassword } = this.state;
    // console.log("testing-------------->", verifyEmail)
    var errMsg = emailValidator(verifyEmail);
    if (errMsg != "") {
      toast.error(errMsg != "" ? errMsg : "", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    } else {
      if (verifyEmail != " ") {
        this.setState({ isLoading: true });
        this.isCheckEmailPresent(e);
      }
    }
  }

  getOtp() {
    const { verifyEmail, is_verifyEmail, is_forgotPassword } = this.state;
    this.props
      .getOtp_action(verifyEmail)
      .then((data) => {
        if (data.error != 1) {
          // session
          sessionStorage.setItem("NODE_OTP", data.data);
          this.setState({ is_forgotPassword: !is_forgotPassword });
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false, email: "" });
          toast.error(data.msg, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  isCheckEmailPresent(e) {
    e.preventDefault();
    const { verifyEmail, is_verifyEmail, is_forgotPassword } = this.state;
    this.props
      .forgetPassword_action(verifyEmail)
      .then((data) => {
        if (data.error != 1) {
          toast.success("OTP Send on your Email", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          // console.log("FORG", data.data[0]['UserID'])
          sessionStorage.setItem("userIdForget", data.data[0]["UserID"]);
          this.getOtp();
          this.setState({
            is_verifyEmail: !is_verifyEmail,
            is_forgotPassword: !is_forgotPassword,
          });
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false, email: "" });
          toast.error(data.msg, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const {
      userEmail,
      password,
      isLoading,
      is_rememberme,
      is_verifyEmail,
      is_verifyOTP,
      email,
      is_showpass,
      is_forgotPassword,
      verifyEmail,
      userName,
      getOtp,
      forgetNewPass,
      forgetConfirmPass,
      finalForgetButton,
    } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {/* <AdminHeader isSteper={false}/> */}
        <>
          <main>
            <div class="login">

              <div class="wrap">
                {/* TOGGLE */}
                <marquee
                  style={{ fontSize: "16px", color: "#000", fontWeight: "500" }}
                  behavior="scroll"
                  direction="left"
                  scrollamount="5"
                  onMouseOver={(e) => e.target.stop()}
                  onMouseOut={(e) => e.target.start()}
                >
                  <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                </marquee>
                <div id="toggle-wrap">
                  <div id="toggle-terms">
                    <div id="cross" onClick={this.toggleModal}>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>

                {/* <!-- RECOVERY --> */}

                <div class="recovery">
                  <h6>Forgot Password</h6>
                  <p>
                    Enter your <strong>email address</strong> on the account and{" "}
                    <strong>click Submit</strong>
                  </p>
                  <p>We'll email instructions on how to reset your password.</p>

                  {is_forgotPassword && (
                    <div className="form">
                      <input
                        type="text"
                        class="input"
                        id="user_recover"
                        value={verifyEmail}
                        placeholder="Enter your Email"
                        onChange={(e) =>
                          this.setState({ verifyEmail: e.target.value })
                        }
                        maxLength={50}
                      />

                      <input
                        type="submit"
                        class="button verify_email w-20px"
                        value="Verify Email"
                        onClick={(e) => this.onVerifyEmail(e)}
                      />
                    </div>
                  )}
                  {is_verifyEmail && (
                    <div className="form">
                      <input
                        type="text"
                        class="input"
                        id="user_recover"
                        value={verifyEmail}
                        disabled={true}
                      />
                      <input
                        type="text"
                        class="input"
                        id="user_recover"
                        maxLength={6}
                        placeholder="Enter OTP"
                        value={getOtp}
                        onChange={(e) =>
                          this.setState({
                            getOtp: e.target.value.replace(/\D/, ""),
                          })
                        }
                      />
                      <input
                        type="submit"
                        class="button verify_OTP"
                        value="Verify OTP"
                        onClick={() => this.onVerifyOTP()}
                      />
                    </div>
                  )}
                  {is_verifyOTP && (
                    <div className="form">
                      <input
                        type="text"
                        class="input"
                        id="user_recover"
                        maxLength={25}
                        placeholder="New Password"
                        onChange={(e) =>
                          this.setState({ forgetNewPass: e.target.value })
                        }
                        value={forgetNewPass}
                      />
                      <input
                        type="text"
                        class="input"
                        id="user_recover"
                        maxLength={25}
                        placeholder="Confirm Password"
                        onChange={(e) =>
                          this.setState({ forgetConfirmPass: e.target.value })
                        }
                        value={forgetConfirmPass}
                      />
                      <input
                        type="submit"
                        class="button Set_Password"
                        value="Set Password"
                        onClick={(e) => {
                          this.updatePassword(e);
                        }}
                      />
                    </div>
                  )}
                </div>

                {/* <!-- SLIDER --> */}
                {/* <div class="content">
                  <div class="logo">
                    <a href="#">
                      <img
                        src="img/ITME_CENTER_LOGO.png"
                        alt="logo"
                        style={{ width: "100px" }}
                      />
                    </a>
                  </div>
                  <div id="slideshow">
                    <div class="one">
                      <h2>
                        <span>EVENTS</span>
                      </h2>
                      <p>
                        Sign up to attend any of hundreds of events nationwide
                      </p>
                    </div>
                    <div class="two">
                      <h2>
                        <span>LEARNING</span>
                      </h2>
                      <p>
                        Thousands of instant online classes/tutorials included
                      </p>
                    </div>
                    <div class="three">
                      <h2>
                        <span>GROUPS</span>
                      </h2>
                      <p>
                        Create your own groups and connect with others that
                        share your interests
                      </p>
                    </div>
                    <div class="four">
                      <h2>
                        <span>SHARING</span>
                      </h2>
                      <p>
                        Share your works and knowledge with the community on the
                        public showcase section
                      </p>
                    </div>
                  </div>
                </div> */}

                <div class="content">
                  <div class="logo">
                    <a><img src="img/main-logo-green.png" alt="" style={{ width: "220px" }} /></a>
                  </div>
                  <img src="/img/down__2__page-0001-removebg-preview.png" class="log-bottom-img" />

                </div>

                {/* <!-- LOGIN FORM --> */}
                <div class="user">
                  {/* <!-- ACTIONS
                                <div class="actions">
                                  <a class="help" href="#signup-tab-content">Sign Up</a><a class="faq" href="#login-tab-content">Login</a>
                                </div>
                    --> */}
                  <div class="form-wrap">
                    {/* <!-- TABS --> */}
                    <div class="tabs">
                      <h3 class="login-tab">
                        <a
                          style={{ textDecoration: "none" }}
                          class="log-in active"
                        >
                          <span>Login</span>
                        </a>
                      </h3>
                      <h3 class="signup-tab">
                        <a
                          style={{ textDecoration: "none" }}
                          class="sign-up"
                          onClick={this.navigateSignUp}
                        >
                          <span>Sign Up</span>
                        </a>
                      </h3>
                    </div>
                    {/* <!-- TABS CONTENT --> */}
                    <div class="tabs-content">
                      {/* <!-- TABS CONTENT LOGIN --> */}
                      <div id="login-tab-content" class="active form">
                        <div class="login-form" action="" method="post">
                          <input
                            type="text"
                            className="input"
                            placeholder="Email "
                            value={userEmail}
                            onChange={(e) =>
                              this.setState({ userEmail: e.target.value })
                            }
                            onKeyDown={(e) => this.handleKeyDown(e)}
                            maxLength={50}
                          />
                          <div style={{ overflow: "hidden" }}>
                            <input
                              type={is_showpass ? "text" : "password"} // Change "type" to "text" when is_showpass is true
                              class="input"
                              placeholder="Password"
                              value={password}
                              onChange={(e) => this.setState({ password: e.target.value })}
                              onKeyDown={(e) => this.handleKeyDown(e)}
                              maxLength={25}
                            />
                            <i style={{
                              color: "black",
                              position: "relative",
                              fontSize: "20px",
                              top: "-44px",
                              left: "290px",
                              cursor: "pointer"
                            }}
                              className={`fa ${is_showpass ? "fa-eye-slash" : "fa-eye"} show-password`} // Use "fa-eye-slash" when is_showpass is true
                              onClick={() => this.setState((prevState) => ({ is_showpass: !prevState.is_showpass }))} // Toggle is_showpass state
                            ></i>
                          </div>
                          <input
                            type="checkbox"
                            class="checkbox"
                            id="remember_me"
                          />
                          <label for="remember_me">Remember me</label>
                          <a
                            class="btn btn-primary login_btn"
                            onClick={(e) => this.handleSubmit(e)}
                          >
                            Login
                          </a>
                          {/* <a class="btn btn-primary login_btn">Login</a> */}
                          {/* <!-- <input type="submit" class="button" value="Login"> --> */}
                        </div>
                        <div class="help-action">
                          <span>
                            <i class="fa fa-arrow-left" aria-hidden="true"></i>
                            &nbsp;&nbsp;&nbsp;
                            <a
                              class="forgot"
                              style={{
                                textDecoration: "none",
                                cursor: "pointer",
                              }}
                              onClick={this.toggleModal}
                            >
                              Forgot your password?
                            </a>
                          </span>
                        </div>
                      </div>
                      {/* <!-- TABS CONTENT SIGNUP --> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </>
        {/* <Footerlogin /> */}
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    login_action,
    forgetPassword_action,
    getOtp_action,
    update_action,
    booking_Details_action,
  })(Login)
);
